export default __webpack_public_path__ + "static/product1-4671ec60b5217a2726842f66eddf4519.png";